import moment from "moment-timezone";
import { DateRange } from "../api/agritech";
import { ChartConfig } from "../constants/charts";

export const defaultChartOptions = (
  axis: ChartConfig["axis"],
  legend: boolean,
  range: DateRange,
  chartEvents: any,
  fieldId?: string
) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: "tooltipByMouseDistance",
    },
    animation: false,
    elements: {
      line: {
        fill: false,
        tension: 0.2,
      },
    },
    scales: {
      x: {
        display: true,
        type: "time",
        time: {
          tooltipFormat: "DD/MM/YYYY HH:mm",
          displayFormats: {
            hour: "ha MMM D",
          },
        },
        grid: {
          display: false,
        },
        min: moment(range.start_date),
        max: moment(range.end_date),
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          maxTicksLimit: 9,
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: axis.x.label,
        },
        suggestedMax: axis.y.max,
        beginAtZero: false,
      },
      ...(axis.y2
        ? {
            y2: {
              type: "linear",
              display: true,
              position: "right",
              title: {
                display: true,
                text: axis.y2.label,
              },
              suggestedMax: axis.y2.max,
              beginAtZero: false,
            },
          }
        : undefined),
    },
    plugins: {
      filler: false,
      fillerAgritech: true,
      decimation: {
        enabled: true,
      },
      legend: {
        display: legend,
        position: "bottom",
        labels: {
          boxWidth: 5,
          usePointStyle: true,
          filter: (item: any, chart: any) =>
            chart.datasets[item.datasetIndex]?.data.length,
        },
        onClick: (
          _e: unknown,
          legendItem: { text?: string; hidden?: boolean; datasetIndex: number },
          legend: {
            chart: {
              isDatasetVisible: (index: number) => boolean;
              hide: (index: number) => void;
              show: (index: number) => void;
            };
          }
        ) => {
          const ci = legend.chart;
          const index = legendItem.datasetIndex;
          const wasVisible = ci.isDatasetVisible(index);
          if (wasVisible) {
            ci.hide(index);
            legendItem.hidden = true;
          } else {
            ci.show(index);
            legendItem.hidden = false;
          }
          if (
            legendItem.text !== "Negative Gains" &&
            legendItem.text !== "Positive Gains"
          )
            return;
          const selectedGain =
            legendItem.text === "Positive Gains" ? "positive" : "negative";
          const positiveKey = "displayPositiveGains" + fieldId?.toString();
          const negativeKey = "displayNegativeGains" + fieldId?.toString();
          const newStoredValue = (!wasVisible).toString();
          if (selectedGain === "positive") {
            localStorage.setItem(positiveKey, newStoredValue);
          } else if (selectedGain === "negative") {
            localStorage.setItem(negativeKey, newStoredValue);
          }
        },
      },
      zoom: {
        limits: {
          x: {
            min: moment(range.start_date),
            max: moment(range.end_date),
            minRange: 1000 * 60 * 60 * 6, // 6 hours
          },
        },
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          drag: {
            enabled: true,
          },
          wheel: {
            enabled: true,
            modifierKey: "shift",
          },
          pinch: {
            enabled: true,
          },
          mode: "x",
          onZoomComplete: chartEvents.onZoomComplete,
        },
      },
      crosshair: {
        sync: {
          enabled: true,
          group: 1,
          suppressTooltips: false,
        },
      },
    },
  };
};
